import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { GameFont } from "../../../common/GameFont";

export class PiggyClubSupportedBuildings extends Container {
    private readonly roundedRectangle: Sprite;
    private readonly buildingIcon: Sprite;
    private readonly supportedBuildingsText: Text;

    public constructor(commonResources: CommonResourcesPackage, supportedBuildingsValue?: number) {
        super();
        this.roundedRectangle = new Sprite(commonResources.assets_common_ui_rounded_rectangle_png);
        this.buildingIcon = new Sprite(commonResources.assets_common_ui_building_icon_png);
        this.buildingIcon.position.set(18, 8);
        this.supportedBuildingsText = new Text(supportedBuildingsValue ?? 0, new ComponentTextStyle());
        const supportedBuildingsTextStartPositionX = this.buildingIcon.position.x + this.buildingIcon.width;
        this.supportedBuildingsText.position.set(supportedBuildingsTextStartPositionX + (this.roundedRectangle.width - supportedBuildingsTextStartPositionX - this.supportedBuildingsText.width) * 0.5, 22);

        this.addChild(
            this.roundedRectangle,
            this.buildingIcon,
            this.supportedBuildingsText
        );
    }
}

class ComponentTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 29,
            fill: 'FFFFFF'
        });
    }
}
